import React from 'react'
import { pure } from 'recompose'
import { Helmet } from 'react-helmet'

const Seo = pure(() => <Helmet />)

export default Seo
